export default function Farmacia(){
    return(
        <div></div>
    );
}
